import { Helmet } from "react-helmet";
import Slider from "react-slick";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <div className="newpage blog_page ICO_txtcontent">
      <NewHead />
      <div className="paddin_immner">
        <main className="carer_page ico_development_page_main">
          <span>
            <Helmet>
              <title>ICO Development Company</title>
              <link
                rel="canonical"
                href="https://www.beleaftechnologies.com/ico-development-company"
              />
              <meta name="title" content="ICO Development Company " />
              <meta
                name="description"
                content="As a leading ICO development company, we offer a host of ICO development solutions – from ICO token development, ICO website development to ICO marketing. We provide ICO Development services in ERC20 token development and ICO website script ."
              />
              <meta
                name="keywords"
                content="ICO Development Company, ICO Development Services, Initial Coin Offering Services, White Label ICO Solutions,ICO Software Development Company, ICO Software Development Services,ICO for Fundraising"
              />
            </Helmet>
            <section className="ico_dev_hero_section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="ico_dev_hero_conent">
                      <h1>ICO Development Company</h1>
                      <p>
                        Mission-driven ICO Development Services will accentuate
                        fundraising and energize your firm for long-term
                        success.
                      </p>
                      <button
                        className="get_free_button_ico"
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Get Free Consultation"
                      >
                        Get Free Consultation
                      </button>
                      <img
                        src={require("../../image/ICO_new/how_ico_bg.webp")}
                        className="banner_ico_bg"
                        alt="ICO Development Company"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_dev_hero_banner">
                      <img
                        src={require("../../image/ICO_new/ico_hero_banner.webp")}
                        alt="ICO Development Company"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="connect_ico_content_section">
              <div className="container">
                <div className="connect_ico_content_box">
                  <h2>ICO Development Company</h2>
                  <p>
                    Every concept necessitates a one-of-a-kind answer! When it
                    comes to making your vision a reality, there are several
                    obstacles to face. As a recognised ICO development company,
                    we provide a wide range of services and specialise in
                    supporting you in overcoming technological challenges with
                    our cutting-edge solutions.
                  </p>

                  <p>
                    We walk you through the whole ICO development process, from
                    initial concept to token design conceptualization, white
                    paper preparation, token development, launch, and marketing.
                    We've assembled a technical team of experts to develop a
                    one-of-a-kind solution that excels at creating high-quality
                    results.
                  </p>
                  <button
                    className="get_free_button_ico"
                    data-toggle="modal"
                    data-target="#myModal"
                    aria-label="Get Free Consultation"
                  >
                    Get Free Consultation
                  </button>
                </div>
              </div>
            </section>
            <section className="ico_initial_coin_offering_section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-7">
                    <div className="ico_initial_coin_offering_content">
                      <h2>What is Initial Coin Offering (ICO)</h2>
                      <p>
                        Initial Coin Offering (ICO) is a crowdfunding mechanism
                        for a project in which the project's developers sell ICO
                        crypto tokens to investors in return for
                        cryptocurrencies or fiat money to support the project's
                        development. Whenever the value of the sold tokens
                        rises, the investors will profit greatly. Join together
                        with our ICO Token Development Company to launch your
                        token right now!
                      </p>{" "}
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="get_free_button_ico"
                      >
                        Let’s Discuss
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-5 justfy_content_img">
                    <div className="ico_initial_coin_offering_img">
                      <img
                        src={require("../../image/ICO_new/what_ico_banner.webp")}
                        alt="ICO Development Company"
                      />
                      <img
                        src={require("../../image/ICO_new/how_ico_bg.webp")}
                        className="what-is-ico-bg"
                        alt="ICO Development Company"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="ico_development_solution_section">
              <div className="container">
                <div className="ico_development_solution_title">
                  <h2>
                    ICO Development Solution
                    <br /> For Multiple Business Verticals
                  </h2>
                  <p>
                    To satisfy our customers' needs, our talented developers
                    produce a range of scalable solutions. Our end-to-end
                    ICOdevelopment solutions are revolutionising the way
                    companies deliver services across numerous industries.
                  </p>
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="ico_nft_project_card">
                      <div className="ico_nft_project_card2">
                        <img
                          src={require("../../image/ICO_new/ico_nft_icon.webp")}
                          alt="ICO Development Company"
                        />
                        <h4>ICO for NFT Project</h4>
                        <p>
                          We offer startup crowdfunding opportunities by
                          launching initial coin offers (ICOs) for Defi project
                          because we are specialists at designing solutions for
                          various types of businesses and excel at helping you
                          scale yours.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="ico_nft_project_card">
                      <div className="ico_nft_project_card2">
                        <img
                          src={require("../../image/ICO_new/ico_blockchain_icon.webp")}
                          alt="ICO Development Company"
                        />
                        <h4>ICO for Blockchain Project</h4>
                        <p>
                          We create a safe crowdfunding platform for businesses
                          and aspiring entrepreneurs by launching a successful
                          ICO for any blockchain-related project.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="ico_nft_project_card">
                      <div className="ico_nft_project_card2">
                        <img
                          src={require("../../image/ICO_new/ico_defi_icon.webp")}
                          alt="ICO Development Company"
                        />
                        <h4>ICO for DeFi Project</h4>
                        <p>
                          We offer startup crowdfunding opportunities by
                          launching initial coin offers (ICOs) for Defi project
                          because we are specialists at designing solutions for
                          various types of businesses and excel at helping you
                          scale yours.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  className="get_free_button_ico"
                  data-toggle="modal"
                  data-target="#myModal"
                  aria-label="Get Free Consultation"
                >
                  Get Free Consultation
                </button>
              </div>
            </section>
            <section className="how_does_ico_work_section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="how_does_ico_work_banner">
                      <img
                        src={require("../../image/ICO_new/how_ico_asset.webp")}
                        alt="ICO Development Company"
                      />
                      <img
                        src={require("../../image/ICO_new/how_ico_bg.webp")}
                        alt="ICO Development Company"
                        className="how_ico_bg"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_initial_coin_offering_content">
                      <h2>How Does An ICO Work?</h2>
                      <p>
                        Beleaf, as an ICO development company, creates a
                        business strategy for ICO launch services by researching
                        the industry, which allows you to learn about the funds
                        to be generated and the first funds required by your
                        organisation. As part of the ICO token development
                        services, other services such as whitepaper writing and
                        marketing are launched.
                      </p>
                      <p>
                        People who want the tokens or crypto coins will purchase
                        them from you, and these coins, like an Initial Public
                        Offering (IPO), will represent the organization's
                        shares. If the requisite funds are raised using these
                        ICO tokens, it means that the Initial Coin Offering
                        Development project's aim has been met successfully.
                      </p>
                      <button
                        className="get_free_button_ico"
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Get Free Consultation"
                      >
                        Schedule A Meeting
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="ico_development_solution_section">
              <div className="container">
                <div className="ico_development_solution_title">
                  <h2>Our Exclusive ICO Development Solutions</h2>
                  <p>
                    We offer a variety of services as one of the best ICO
                    development service providers, including
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="get_free_button_ico"
                  >
                    Get A Quote
                  </button>
                  <img
                    src={require("../../image/ICO_new/our_excluive_banner.webp")}
                    alt="ICO Development Company"
                  />
                </div>
              </div>
            </section>
            <section className="ico_blockchain_platform_section">
              <div className="container">
                <div className="ico_development_solution_title margin_bottom_content">
                  <h2 className="ico_block-mw">
                    Blockchain Platforms Our ICO Development Company
                  </h2>
                  <p>
                    We are available to offer a wide range of blockchain
                    platforms that our ICO development company uses because we
                    are experts in blockchain technology. The leading blockchain
                    platforms that we provide are listed Below:
                  </p>
                </div>
                <Slider {...processes_newew}>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/eth.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Ethereum</div>
                    <img
                      src={require("../../image/ICO_new/eth_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/polkadot.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Polkadot</div>
                    <img
                      src={require("../../image/ICO_new/Polkadot_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/solana.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Solana</div>
                    <img
                      src={require("../../image/ICO_new/solana_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/bnb.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">BNB Chain</div>
                    <img
                      src={require("../../image/ICO_new/bnb_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/tron.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">TRON</div>
                    <img
                      src={require("../../image/ICO_new/tron_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/algorand.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Algorand</div>
                    <img
                      src={require("../../image/ICO_new/algorand_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/base_chain.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Base Chain</div>
                    <img
                      src={require("../../image/ICO_new/base_chain_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/avalanche.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Avalanche</div>
                    <img
                      src={require("../../image/ICO_new/avalanche_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/polygon.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Polygon</div>
                    <img
                      src={require("../../image/ICO_new/polygon_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/near_protocol.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Near Protocol</div>
                    <img
                      src={require("../../image/ICO_new/near_protocol_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/cardano.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Cardano</div>
                    <img
                      src={require("../../image/ICO_new/cardano_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/tezos.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Tezos</div>
                    <img
                      src={require("../../image/ICO_new/tezos_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                  <div className="ico_dev_sol_eth">
                    <img
                      src={require("../../image/ICO_new/cosmos.webp")}
                      alt="ICO Development Company"
                    />
                    <div className="ico_dev_sol_text">Cosmos</div>
                    <img
                      src={require("../../image/ICO_new/cosmos_bg.webp")}
                      alt="ICO Development Company"
                      className="ico_new_eth_bg"
                    />
                  </div>
                </Slider>
              </div>
            </section>
            <section className="our_ico_development_stage_section">
              <div className="container">
                <div className="ico_development_solution_title margin_bottom_content">
                  <h2>Our ICO Development Stages</h2>
                  <p>
                    We are the premier ICO development company since we provide
                    all ICO-related development services that will help you
                    <br /> succeed with your business idea.
                  </p>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="ico_validatio_and_ideation_card1">
                      <img
                        src={require("../../image/ICO_new/creative_idea.png")}
                        alt="ICO Development Company"
                      />
                      <div className="ico_validatio_and_ideation_card2">
                        <h3>Validation and Ideation</h3>
                        <p>
                          Our blockchain experts evaluate your concept to
                          determine its acceptability, practicality, and
                          viability.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_validatio_and_ideation_card1">
                      <img
                        src={require("../../image/ICO_new/top_white_paper.png")}
                        alt="ICO Development Company"
                      />
                      <div className="ico_validatio_and_ideation_card2">
                        <h3>White Paper Writing</h3>
                        <p>
                          Our technical content writers provide clear, relevant,
                          and powerful information to successfully communicate
                          your ideas through the paper.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_validatio_and_ideation_card1">
                      <img
                        src={require("../../image/ICO_new/design_landing_icon.png")}
                        alt="ICO Development Company"
                      />
                      <div className="ico_validatio_and_ideation_card2">
                        <h3>Designing a Landing Page</h3>
                        <p>
                          We create a appealing and informative landing page to
                          showcase your idea to the target audience. UI/UX is
                          carefully considered by our professionals throughout
                          the building of an ICO website.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_validatio_and_ideation_card1">
                      <img
                        src={require("../../image/ICO_new/pre_ico_icon.png")}
                        alt="ICO Development Company"
                      />
                      <div className="ico_validatio_and_ideation_card2">
                        <h3>Pre - ICO Promotion</h3>
                        <p>
                          We distribute compelling brand messaging and content
                          across platforms such as Steemit, Telegram, Reddit,
                          Twitter, LinkedIn, and others
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_validatio_and_ideation_card1">
                      <img
                        src={require("../../image/ICO_new/token_creation.png")}
                        alt="ICO Development Company"
                      />
                      <div className="ico_validatio_and_ideation_card2">
                        <h3>Token Creation</h3>
                        <p>
                          Our blockchain engineers will create a token based on
                          your selected standard, whether it be ERC20 token
                          development or another standard.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_validatio_and_ideation_card1">
                      <img
                        src={require("../../image/ICO_new/wallet_con.png")}
                        alt="ICO Development Company"
                      />
                      <div className="ico_validatio_and_ideation_card2">
                        <h3>Wallet Construction</h3>
                        <p>
                          We offer a highly secure and adaptable wallet
                          infrastructure (enhanced by multisig and
                          multi-cryptocurrency compatibility) for sending,
                          receiving, and storing coins and tokens.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="pre_ico_launch_section">
              <div className="container">
                <h2>Pre - ICO Launch Services</h2>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="ico_p2p_marketing_card">
                      <img
                        src={require("../../image/ICO_new/pr_marking.webp")}
                        alt="ICO Development Company"
                      />
                      <h3>PR & Marketing</h3>
                      <p>
                        We assess your strengths and learn about your
                        competition in order to design a successful PR and
                        marketing plan for your ICO.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_p2p_marketing_card">
                      <img
                        src={require("../../image/ICO_new/white_paper.webp")}
                        alt="ICO Development Company"
                      />
                      <h3>White Paper</h3>
                      <p>
                        Our professionals create whitepaper services to help you
                        showcase your company more professionally to potential
                        ICO investors.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_p2p_marketing_card">
                      <img
                        src={require("../../image/ICO_new/prospectus.webp")}
                        alt="ICO Development Company"
                      />
                      <h3>Prospectus</h3>
                      <p>
                        We write a detailed prospectus to clearly communicate
                        the benefits of the business and entice the audience to
                        purchase the currency.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_p2p_marketing_card">
                      <img
                        src={require("../../image/ICO_new/ico_landingpage.webp")}
                        alt="ICO Development Company"
                      />
                      <h3>Landing Page</h3>
                      <p>
                        A user-friendly and informative landing page with social
                        evidence, intuitively built to attract investors to get
                        started.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_p2p_marketing_card">
                      <img
                        src={require("../../image/ICO_new/smart_contract.webp")}
                        alt="ICO Development Company"
                      />
                      <h3>Smart Contract Set Up</h3>
                      <p>
                        We provide secure and dependable smart contract
                        development services to standardise and automate your
                        business processes.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="ico_p2p_marketing_card">
                      <img
                        src={require("../../image/ICO_new/book_exp.webp")}
                        alt="ICO Development Company"
                      />
                      <h3>Block Explorer Add On</h3>
                      <p>
                        A standard block explorer is a particular tool that
                        provides full information about bitcoin blocks,
                        addresses, and transactions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="pre_ico_launch_section">
              <div className="container">
                <h2>Post - ICO Launch Services</h2>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="ico_p2p_marketing_card">
                      <img
                        src={require("../../image/ICO_new/exchange_lisiting.webp")}
                        alt="ICO Development Company"
                      />
                      <h3>Exchange Listing Assistance</h3>
                      <p>
                        We assist you in listing your tokens or currencies on
                        the top exchange platforms and merchant platforms.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ico_p2p_marketing_card">
                      <img
                        src={require("../../image/ICO_new/price_vol.webp")}
                        alt="ICO Development Company"
                      />
                      <h3>Price Volatility</h3>
                      <p>
                        Our exceptional service in altcoin price volatility and
                        hedging will safeguard your coin value from fluctuation
                        and decrease hazards over time.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="ico_initial_coin_offering_section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-7">
                    <div className="ico_initial_coin_offering_content">
                      <h2>
                        Why Should You Work With Beleaf For ICO Development?
                      </h2>
                      <p>
                        Beleaf is a forerunner in ICO development, offering pre-
                        and post-ICO launch services and solutions in a variety
                        of business sectors. Our expert developers construct and
                        develop your Token on top of Blockchain Platforms before
                        successfully launching your ICO, which aids in the
                        raising of cash for businesses/startups/projects.
                      </p>{" "}
                      <div>
                        <a href="https://wa.me/7904323274">
                          <button className="get_free_button_ico">
                            Hire Our Blockchain Experts
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5 justfy_content_img">
                    <div className="ico_initial_coin_offering_img">
                      <img
                        src={require("../../image/ICO_new/why_ico_banner.webp")}
                        alt="ICO Development Company"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="bg-white">
              {/* faq */}
              <article className="primary__landing-content-container">
                <div className="landing-faq-wrapper">
                  <div className="row">
                    <div className="col-lg-6">
                      <h6 className="landing-faq-left-title">
                        Frequently Asked{" "}
                        <span className="faq-span">Questions.</span> {""}
                      </h6>
                    </div>
                    <div className="col-lg-6">
                      <div>
                        <div className="container">
                          <div className="accordion" id="faq">
                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead1">
                                <button
                                  className="landing-faq-title collapsed"
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#faq1"
                                  aria-expanded="true"
                                  aria-controls="faq1"
                                >
                                  How should an ICO be assessed?
                                </button>
                              </div>

                              <div
                                id="faq1"
                                className="collapse"
                                aria-labelledby="faqhead1"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  The best method to evaluate an ICO is to
                                  examine all components of the project,
                                  including the business model, project team,
                                  community comments, VC involvement, market
                                  niche, and current product state, and then
                                  narrow it down to their specific plan.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead2">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq2"
                                  aria-expanded="true"
                                  aria-controls="faq2"
                                >
                                  How can you get started with your own ICO?
                                </div>
                              </div>

                              <div
                                id="faq2"
                                className="collapse"
                                aria-labelledby="faqhead2"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  Conduct significant industry research and
                                  choose a trusted company, such as Beleaf, to
                                  quickly launch your own ICO. We at Beleaf
                                  offer both post-ICO and pre-ICO launch
                                  services because we are faster and less
                                  expensive than others.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead3">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq3"
                                  aria-expanded="true"
                                  aria-controls="faq3"
                                >
                                  What are the benefits of an Initial Coin
                                  Offering (ICO)?
                                </div>
                              </div>

                              <div
                                id="faq3"
                                className="collapse"
                                aria-labelledby="faqhead3"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  Simple fundraising: The initial coin offering
                                  (ICO) is the best approach to raise funding
                                  for blockchain-based projects.
                                  <br />
                                  International reach: An ICO allows you to
                                  reach the global market without any hassle.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead4">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq4"
                                  aria-expanded="true"
                                  aria-controls="faq4"
                                >
                                  What is an ICO bounty program?
                                </div>
                              </div>

                              <div
                                id="faq4"
                                className="collapse"
                                aria-labelledby="faqhead4"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  ICO Bounty is a reward program for promoting
                                  an ICO to the appropriate audience. Bounty
                                  programs encompass a variety of activities
                                  such as producing articles, advertising ICO
                                  projects on social media, translating
                                  whitepapers into multiple languages, and more.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead5">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq5"
                                  aria-expanded="true"
                                  aria-controls="faq5"
                                >
                                  What steps do you take to create an ICO?
                                </div>
                              </div>

                              <div
                                id="faq5"
                                className="collapse"
                                aria-labelledby="faqhead5"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  It completely relies on the type of ICO you
                                  have and the requirements it has. We construct
                                  the actual token for you, inform you about the
                                  best practices of the crypto community, and
                                  build a website and whatever else you need for
                                  development.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </section>
          </span>
        </main>
      </div>

      <ServiceFooter />
    </div>
  );
}

export default Cex;
